module.exports = __webpack_public_path__ + "static/media/cloud.fa689483.svg";